import { EventListPresenterState } from "../../../blocks/EventListPresenter/state";
import { Event } from "../../../contracts";
import { BaseDict } from "../../../blocks/EventListPresenter/dict";
import { getFixtureCardProps } from "../getFixtureCardProps";
import { getOutrightCardProps } from "../getOutrightCardProps";
import { getAggregateCardProps } from "../getAggregateCardProps";
import { EventsBySportIdRequest } from "sb-resp-lib";

export const EventCardPropsMapper = {
    [EventsBySportIdRequest.EventTypesEnum.Fixture]: (state: EventListPresenterState, event: Event, cms: any, dict: BaseDict) => getFixtureCardProps(state, event, cms, dict),
    [EventsBySportIdRequest.EventTypesEnum.AggregateFixture]: (state: EventListPresenterState, event: Event, dict: BaseDict) => getAggregateCardProps(state, event, dict),
    [EventsBySportIdRequest.EventTypesEnum.Outright]: (state: EventListPresenterState, event: Event, cms: any, dict: BaseDict) => getOutrightCardProps(state, event, cms, dict)
}